module.exports = __webpack_public_path__ + "static/media/Calendar-fill.c590be8c.gif";